import(/* webpackMode: "eager" */ "/srv/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/srv/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/srv/src/shared/components/container/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/srv/src/shared/components/header/Component.tsx");
;
import(/* webpackMode: "eager" */ "/srv/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/srv/src/styles/_reset.scss");
